import { Injectable, TemplateRef, ViewContainerRef } from '@angular/core';
import { TemplatePortal } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class TemplatePortalFactoryService {
  newTemplatePortal(
    template: TemplateRef<any>,
    viewContainerRef: ViewContainerRef,
    context?: any
  ): TemplatePortal<any> {
    return new TemplatePortal(template, viewContainerRef, context);
  }
}
